/** Namespace `mailProviders` — bản gốc tiếng Việt (PLAT-2026-135 lát N). Khoá phẳng; `{biến}` để chèn. */
export const mailProviders = {
  configureProviders: "Thiết lập nhà cung cấp email",
  title: "Tài khoản gửi email",
  subtitle:
    "Hub đọc tài khoản Resend / Elastic Email / Amazon SES bằng khoá QUẢN TRỊ của từng bộ thông số (khoá chỉ nằm ở hub, không xuống app) — 10 phút một lần, hoặc khi bấm « Đọc lại ». Mỗi số kèm nguồn.",
  back: "← Gửi mail",
  backList: "← Mọi nhà cung cấp",
  loading: "Đang tải…",
  loadFailed: "Không đọc được tài khoản nhà cung cấp.",
  empty: "Chưa có bộ thông số Resend / Elastic Email / Amazon SES nào — thêm ở trang Tích hợp.",
  open: "Chi tiết",
  refresh: "Đọc lại",
  refreshing: "Đang đọc…",
  checkedAt: "Đọc lúc {at}",
  neverChecked: "chưa đọc lần nào",
  "col.set": "Bộ thông số",
  "col.read": "Đọc tài khoản",
  "col.quota": "Hạn mức",
  "col.account": "Tài khoản",
  "col.webhook": "Sự kiện giao thư",
  "col.checked": "Đọc lúc",
  "env.live": "Live",
  "env.sandbox": "Sandbox",
  "provider.resend": "Resend",
  "provider.elasticmail": "Elastic Email",
  "provider.ses": "Amazon SES",
  "read.ok": "Đọc được",
  "read.no_key": "Chưa có khoá quản trị",
  "read.error": "Lỗi",
  "read.decrypt_failed": "Hub không mở được bộ",
  "read.never": "Chưa đọc",
  "readHint.no_key":
    "Bộ này chưa có khoá QUẢN TRỊ (trường « chỉ ở hub » trong bộ thông số) — hub chỉ hiện được số khai tay. Nhập khoá ở trang Tích hợp.",
  "readHint.decrypt_failed": "Hub không giải mã được bộ thông số này (khoá niêm phong của hub đổi?) — xem log API.",
  "readHint.never": "Chưa đọc lần nào — bấm « Đọc lại ».",
  "error.auth": "Nhà cung cấp từ chối khoá quản trị",
  "error.permission": "Khoá quản trị thiếu quyền",
  "error.not_found": "Không tìm thấy",
  "error.conflict": "Xung đột",
  "error.invalid_request": "Yêu cầu không hợp lệ",
  "error.rate_limited": "Bị giới hạn tốc độ",
  "error.unavailable": "Không gọi được nhà cung cấp",
  "error.invalid_response": "Nhà cung cấp trả về lạ",
  "source.api": "API",
  "source.header": "header",
  "source.manual": "khai tay",
  "source.none": "không biết",
  "metric.messages": "thư",
  "metric.recipients": "người nhận",
  "metric.requests": "lượt gọi",
  "metric.domains": "domain",
  "metric.contacts": "liên hệ",
  "window.rolling_24h": "24 giờ cuộn",
  "window.day": "ngày",
  "window.month": "tháng",
  "window.second": "giây",
  "window.total": "tổng",
  quotaLine: "{metric} / {window}",
  quotaUsed: "{used} / {limit}",
  unlimited: "không trần",
  resetsAt: "đặt lại {at}",
  noQuota: "Nhà cung cấp không có API hạn mức — xem gói / credit khai tay.",
  "tab.overview": "Tổng quan",
  "tab.domains": "Domain",
  "overview.plan": "Gói",
  "overview.quotas": "Hạn mức",
  "overview.rateLimit": "Tốc độ",
  "overview.rateLimitValue": "{limit} lượt / {sec} giây",
  "overview.credits": "Credit",
  "overview.sandbox": "Sandbox",
  "overview.sending": "Cho gửi",
  "overview.enforcement": "Trạng thái thi hành",
  "overview.stats": "Thống kê tháng này",
  yes: "có",
  no: "không",
  unknownValue: "—",
  "enforcement.healthy": "bình thường",
  "enforcement.probation": "đang bị xem xét (PROBATION)",
  "enforcement.shutdown": "bị khoá gửi (SHUTDOWN)",
  "stat.recipients": "người nhận",
  "stat.emails": "thư",
  "stat.delivered": "đã giao",
  "stat.bounced": "bounce",
  "stat.complaints": "khiếu nại",
  "stat.notDelivered": "không giao được",
  "stat.inProgress": "đang gửi",
  "stat.unsubscribed": "huỷ đăng ký",
  "webhook.absent": "Chưa nối",
  "webhook.pending": "Chờ xác nhận",
  "webhook.active": "Đang nhận",
  "webhook.failed": "Hỏng",
  "webhook.lastEvent": "sự kiện gần nhất {at}",
  "tab.events": "Webhook / Sự kiện",
  "events.status": "Trạng thái",
  "events.url": "URL hub nhận",
  "events.connectedAt": "Nối lúc",
  "events.lastEventAt": "Sự kiện gần nhất",
  "events.noEventYet": "chưa nhận sự kiện nào",
  "events.pendingHint.resend": "Đã đăng ký — chờ sự kiện đầu tiên.",
  "events.pendingHint.elasticmail": "Đã đăng ký — chờ sự kiện đầu tiên.",
  "events.pendingHint.ses": "Chờ SNS gửi xác nhận đăng ký — hub tự xác nhận sau khi kiểm chữ ký.",
  "events.what.resend":
    "« Nối webhook » đăng ký URL hub ở Resend cho sự kiện giao thư (đã giao, bounce, khiếu nại, trễ…). Secret ký do Resend cấp chỉ lưu niêm phong ở hub. Bấm lại để kiểm, sửa hoặc xoay.",
  "events.what.elasticmail":
    "« Nối webhook » đăng ký URL hub ở Elastic Email (bật ký HMAC) cho sự kiện giao thư. Secret ký chỉ lưu niêm phong ở hub. Bấm lại để kiểm, sửa hoặc xoay.",
  "events.what.ses":
    "« Nối webhook » dựng ở AWS: topic SNS (chữ ký v2), đăng ký HTTPS tới hub, Configuration Set và Event Destination; rồi ghi `configurationSetName` vào bộ thông số và đẩy xuống app — từ đó thư gửi qua SES mới có sự kiện giao thư.",
  "events.readOnly": "Bạn chỉ có quyền xem. Nối webhook cần quyền `hq.integrations.write`.",
  "events.ensure": "Nối webhook",
  "events.reEnsure": "Kiểm & nối lại webhook",
  "events.counts24h": "24 giờ qua",
  "events.countsEmpty": "Không có sự kiện nào trong 24 giờ qua.",
  "events.recent": "Sự kiện gần nhất",
  "events.empty": "Hub chưa nhận sự kiện giao thư nào của bộ này.",
  "events.col.at": "Lúc",
  "events.col.event": "Sự kiện",
  "events.col.mail": "Thư",
  "events.col.recipient": "Domain người nhận",
  "events.col.diagnostic": "Chẩn đoán",
  "events.confirmTitle": "Nối webhook sự kiện giao thư",
  "events.confirmEffect.resend": "Hub tạo hoặc sửa webhook ở tài khoản Resend này bằng khoá quản trị; secret ký mới (nếu có) chỉ lưu niêm phong ở hub.",
  "events.confirmEffect.elasticmail": "Hub tạo hoặc sửa webhook ở tài khoản Elastic Email này bằng khoá quản trị; secret ký mới (nếu có) chỉ lưu niêm phong ở hub.",
  "events.confirmEffect.ses":
    "Hub tạo / sửa topic SNS, đăng ký HTTPS, Configuration Set và Event Destination ở AWS; ghi `configurationSetName` vào bộ thông số ⇒ phiên bản mới + đẩy cấu hình xuống các app đang dùng bộ.",
  "events.confirm": "Nối webhook",
  "events.ensuring": "Đang nối…",
  "delivery.accepted": "nhận",
  "delivery.sent": "đã gửi đi",
  "delivery.delayed": "trễ",
  "delivery.delivered": "đã giao",
  "delivery.bounced": "bounce",
  "delivery.rejected": "bị từ chối",
  "delivery.complained": "khiếu nại",
  "bounce.hard": "cứng",
  "bounce.soft": "mềm",
  "bounce.unknown": "chưa rõ",
  "attribution.request_tag": "gán theo tag ý định gửi",
  "attribution.mail_tag": "gán theo tag thư",
  "attribution.provider_message_id": "gán theo mã thư của nhà cung cấp",
  "attribution.binding": "gán theo app dùng bộ",
  "attribution.none": "không gán được về app",
  "tab.keys": "Khoá",
  "tab.suppressions": "Danh sách chặn",
  "confirm.cancel": "Huỷ",
  "confirm.failed": "Thao tác không thành công.",
  "confirm.audit": "Thao tác được ghi nhật ký kiểm toán.",
  "confirm.typeSet": "Gõ lại tên bộ « {name} » để xác nhận:",
  "confirm.typeDomain": "Gõ lại tên domain « {name} » để xác nhận:",
  "confirm.typeKey": "Gõ lại tên khoá « {name} » để xác nhận:",
  "confirm.typeEmail": "Gõ lại địa chỉ « {email} » để xác nhận:",
  "domains.add": "Thêm domain",
  "domains.addTitle": "Thêm domain gửi thư",
  "domains.addName": "Tên domain (vd. mail.bube.vn)",
  "domains.addEffect": "Hub tạo domain ở tài khoản nhà cung cấp bằng khoá quản trị. Sau đó thêm các bản ghi DNS hiện ra ở nhà quản lý DNS rồi bấm « Kiểm lại DNS ».",
  "domains.adding": "Đang thêm…",
  "domains.verify": "Kiểm lại DNS",
  "domains.verifying": "Đang kiểm…",
  "domains.remove": "Xoá domain",
  "domains.removeTitle": "Xoá domain {name}",
  "domains.removeEffect": "Nhà cung cấp xoá domain cùng mọi bản ghi xác minh — thư gửi từ domain này bị từ chối ngay.",
  "domains.removing": "Đang xoá…",
  "keys.loadFailed": "Không đọc được danh sách khoá.",
  "keys.readError": "Nhà cung cấp không trả danh sách khoá:",
  "keys.unsupportedProvider": "Nhà cung cấp này không quản lý khoá qua API ({reason}).",
  "keys.empty": "Tài khoản chưa có khoá API nào.",
  "keys.readOnly": "Bạn chỉ có quyền xem. Tạo / xoá khoá cần quyền `hq.integrations.write`.",
  "keys.col.name": "Tên",
  "keys.col.permission": "Quyền",
  "keys.col.domain": "Domain",
  "keys.col.created": "Tạo lúc",
  "keys.col.lastUsed": "Dùng gần nhất",
  "keys.byHub": "hub tạo",
  "keys.inUse": "đang dùng",
  "keys.inUseHint": "Có app đang gửi bằng khoá này (tuyến gửi từ domain của nó, hoặc nó là « API key » của bộ) — tạo khoá mới cho domain trước rồi mới xoá.",
  "keys.never": "chưa dùng",
  "keys.domain": "Domain (đã xác minh)",
  "keys.create": "Tạo khoá gửi mới",
  "keys.createTitle": "Tạo khoá gửi cho một domain",
  "keys.createEffect": "Hub tạo khoá CHỈ GỬI, giới hạn đúng domain đã chọn, rồi lưu theo (bộ, domain). Mọi app có tuyến gửi từ domain này chuyển sang khoá mới ở lượt đẩy kế tiếp; « API key » của bộ giữ nguyên. Khoá không hiện ra màn hình. Khoá cũ của domain giữ nguyên ở nhà cung cấp tới khi bạn xoá.",
  "keys.creating": "Đang tạo…",
  "keys.created": "Đã tạo khoá {name} cho domain {domain}.",
  "keys.createdPushed": "Đã đẩy cấu hình xuống các app gửi từ domain này.",
  "keys.createdIdle": "Chưa app nào gửi từ domain này — khoá sẽ được dùng khi có tuyến gửi từ nó.",
  "keys.perDomain": "Khoá gửi theo domain",
  "keys.perDomainHint": "Một bộ là một tài khoản nhà cung cấp, dùng chung được cho nhiều app. Tuyến của app gửi bằng khoá của domain trong địa chỉ gửi; domain chưa có khoá riêng thì dùng « API key » của bộ.",
  "keys.perDomainEmpty": "Chưa có khoá gửi theo domain nào — mọi tuyến đang gửi bằng « API key » của bộ.",
  "keys.setApiKey": "là « API key » của bộ",
  "keys.noVerifiedDomain": "Chưa có domain nào đã xác minh — thêm và xác minh domain ở tab « Domain » trước khi tạo khoá gửi.",
  "keys.remove": "Xoá",
  "keys.removeTitle": "Xoá khoá {name}",
  "keys.removeEffect": "Nhà cung cấp thu hồi khoá ngay — nơi nào còn dùng khoá này sẽ không gửi được.",
  "keys.removing": "Đang xoá…",
  "supp.loadFailed": "Không đọc được danh sách chặn.",
  "supp.readError": "Nhà cung cấp không trả danh sách chặn:",
  "supp.unsupportedProvider": "Nhà cung cấp này không có API danh sách chặn ({reason}).",
  "supp.hint": "Địa chỉ bị nhà cung cấp chặn (bounce cứng, khiếu nại, thêm tay…) — thư gửi tới đó bị bỏ qua.",
  "supp.fetchedAt": "Đọc từ nhà cung cấp lúc {at} (hub giữ 5 phút, không lưu).",
  "supp.empty": "Không có địa chỉ nào trong danh sách chặn.",
  "supp.col.email": "Địa chỉ",
  "supp.col.origin": "Lý do",
  "supp.col.at": "Chặn lúc",
  "supp.col.detail": "Chi tiết",
  "supp.origin.bounce": "bounce",
  "supp.origin.complaint": "khiếu nại",
  "supp.origin.manual": "thêm tay",
  "supp.origin.unsubscribe": "huỷ đăng ký",
  "supp.origin.unknown": "khác",
  "supp.next": "Trang sau",
  "supp.first": "Về trang đầu",
  "supp.remove": "Gỡ chặn",
  "supp.removeTitle": "Gỡ {email} khỏi danh sách chặn",
  "supp.removeEffect": "Nhà cung cấp sẽ lại gửi thư tới địa chỉ này. Chỉ gỡ khi chắc địa chỉ đã đúng / người nhận đồng ý — gửi lại vào địa chỉ hỏng làm xấu uy tín gửi.",
  "supp.removing": "Đang gỡ…",
  "domains.empty": "Tài khoản chưa có domain nào.",
  "domains.notRead": "Chưa đọc domain (cần khoá quản trị).",
  "domains.sending": "cho gửi",
  "domains.notSending": "chưa cho gửi",
  "domains.col.purpose": "Vai",
  "domains.col.type": "Loại",
  "domains.col.name": "Tên",
  "domains.col.value": "Giá trị",
  "domains.col.status": "Trạng thái",
  "domains.valueHidden": "(xem ở màn nhà cung cấp)",
  "record.verified": "đã xác minh",
  "record.pending": "chờ",
  "record.failed": "hỏng",
  "record.unknown": "chưa rõ",
  "dmarc.title": "Gợi ý DMARC cho {domain}",
  "dmarc.hint": "Domain đang gửi nhưng chưa thấy bản ghi DMARC đã xác minh. Bắt đầu bằng p=none (chỉ quan sát) rồi nâng dần.",
  "dmarc.copy": "Chép",
  "dmarc.copied": "Đã chép",
} as const;
